export default "__VITE_ASSET__BbMvIms1__"